import React, { FC, useMemo } from 'react';
import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';
import { Picture } from '../Image';

const StyledCover = styled.div`
  ${theme.screens.LtMd} {
    margin-left: ${size(-2)};
    margin-right: ${size(-2)};
  }
`;

interface ICover {
  image: {
    url: string;
    alt?: string;
  };
  link?: {
    url: string;
    title: string;
  };
  LinkComponent?: FC | keyof JSX.IntrinsicElements;
}

const Cover = ({ image, link, LinkComponent = 'a' }: ICover) => {
  const imageProps = useMemo(
    () => ({
      image: {
        src: `${image.url}?w=1340`,
        srcSet: `${image.url}?w=630 630w, ${image.url}?w=840 840w,`,
        sizes: '(min-width: 900px) calc(100vw - 32px), (min-width: 1372px) 1340px, 100vw',
        alt: image.alt,
      },
      sources: [
        {
          type: 'image/webp',
          srcSet: `${image.url}?w=630&fm=webp 630w, ${image.url}?w=840&fm=webp 840w, ${image.url}?w=1340&fm=webp 1340w`,
          sizes: '(min-width: 900px) calc(100vw - 32px), (min-width: 1372px) 1340px, 100vw',
        },
      ],
    }),
    [],
  );

  return (
    <StyledCover>
      {link ? (
        <LinkComponent href={link?.url} title={link.title}>
          <Picture {...imageProps} />
        </LinkComponent>
      ) : (
        <Picture {...imageProps} />
      )}
    </StyledCover>
  );
};

export default Cover;
